<script setup>
const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
})
</script>
<template>
    <div>
        <confetti-bomb />
    </div>
</template>

<style scoped>
</style>
